import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import i18n from '../../i18n/i18n.js';
import PageHeader from "../../components/PageHeader/PageHeader.js";
import { ReactSVG } from "react-svg";
import { AppContext } from '../../contexts/AppContext.js';
import AuthPrompt from '../../components/AuthPrompt/AuthPrompt.js';
import Minicart from '../../components/Minicart/Minicart.js';

import './Checkout.css';

const Checkout = () => {
    const appRef = React.useContext(AppContext).appRef;
    const isLoggedIn = appRef.current.get_is_signed();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [continueAsGuest, setContinueAsGuest] = useState(false);

    useEffect(() => {
        // Szimuláljuk a betöltést
        setIsLoading(false);
    }, []);

    const handleContinueWithoutAuth = () => {
        setContinueAsGuest(true);
    };

    if (isLoading) {
        return (
            <div className={`container floating_container checkout`}>
                <div className='floating_container_inner'>
                    <div className='loader_cont'>
                        <div className='loader'>
                            <ReactSVG src='/assets/images/loading.svg'></ReactSVG>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (!isLoggedIn && !continueAsGuest) {
        return (
            <div className={`container floating_container checkout`}>
                <div className='floating_container_inner'>
                    <div className='floating_container_header'>
                        <PageHeader 
                            isHistoryBack="true" 
                            no_close="true" 
                            title={i18n.t('checkoutOrder')}
                        />
                    </div>
                    <div className='floating_container_content'>
                        <div className='checkout_inner'>
                            <AuthPrompt 
                                showContinueWithoutAuth={true}
                                onContinueWithoutAuth={handleContinueWithoutAuth}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Ha be van jelentkezve, vagy vendégként folytatja, akkor a normál checkout folyamat
    return (
        <div className={`container floating_container checkout`}>
            <div className='floating_container_inner'>
                <div className='floating_container_header'>
                    <PageHeader 
                        isHistoryBack="true" 
                        no_close="true" 
                        title={i18n.t('checkoutOrder')}
                    />
                </div>
                <div className='floating_container_content'>
                    <div className='checkout_inner'>
                        <Minicart isCheckout={true} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Checkout;
